import { render, staticRenderFns } from "./SelfHelp.vue?vue&type=template&id=4a794672&scoped=true"
import script from "./SelfHelp.vue?vue&type=script&lang=js"
export * from "./SelfHelp.vue?vue&type=script&lang=js"
import style0 from "./SelfHelp.vue?vue&type=style&index=0&id=4a794672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a794672",
  null
  
)

export default component.exports